import { Box, Typography, Button } from "@mui/material";
import Card from "@mui/material/Card";

/**
 * Daily Cost week title card with Previous / This Week / Next navigation.
 * Each button loads `/v1/getjobcost/...` via `props.getData` and toggles
 * the parent loading flag.
 *
 * @param {Object} props Component props.
 * @param {Object} props.data Daily cost payload (`frontend_data.current_week`,
 *   `prev_week`, `next_week`).
 * @param {Function} props.setIsLoading Parent loading setter.
 * @param {Function} props.setData Parent data setter (cleared before fetch).
 * @param {Function} props.getData Fetcher `(url, setData) => Promise`.
 * @returns {JSX.Element}
 */
const Title = (props) => {
  return (
    <Card
      variant="outlined"
      className="glass-green"
      sx={{
        ml: 2,
        p: 2,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "47%",
        boxShadow: 2,
      }}
    >
      <Typography variant="h5">
        Daily Cost Page
      </Typography>
      <Typography variant="h6">
        Dispatch: <strong>{props.data["frontend_data"]["current_week"]}</strong>
      </Typography>
      <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
        <Button
          variant="contained"
          sx={{ bgcolor: "bold.main" }}
          onClick={() => {
            var url = `/v1/getjobcost/${props.data["frontend_data"]["prev_week"]}`;
            props.setIsLoading(true);
            props.setData(null);
            props
              .getData(url, props.setData)
              .finally(() => props.setIsLoading(false));
          }}
        >
          {" "}
          Previous
        </Button>
        <Button
          variant="contained"
          sx={{ bgcolor: "bold.main" }}
          onClick={() => {
            var url = `/v1/getjobcost/current`;
            props.setIsLoading(true);
            props.setData(null);
            props
              .getData(url, props.setData)
              .finally(() => props.setIsLoading(false));
          }}
        >
          {" "}
          This Week
        </Button>
        <Button
          variant="contained"
          sx={{ bgcolor: "bold.main" }}
          onClick={() => {
            var url = `/v1/getjobcost/${props.data["frontend_data"]["next_week"]}`;
            props.setIsLoading(true);
            props.setData(null);
            props
              .getData(url, props.setData)
              .finally(() => props.setIsLoading(false));
          }}
        >
          {" "}
          Next
        </Button>
      </Box>
    </Card>
  );
};
export default Title;
